'use strict';


const COUNTRIES = require('./util/countries');
const parse = require('./parse/parse');


function parseMRZ(text) {
    return parse(text);
}

module.exports = {
    COUNTRIES,
    parseMRZ
};



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0